import React from 'react';

// A value the backend hasn't fetched yet. The data model still carries the
// text below (so nothing else needed to change); it's shown as a red dash
// with the explanation on hover. Never a guessed value.
export const NOT_AVAILABLE_TEXT = 'Ikke tilgængeligt endnu';

export function MissingDash() {
  return <span className="missing-dash" title="Ikke hentet endnu" aria-label="Ikke hentet endnu">–</span>;
}

// Renders a value, swapping the not-fetched text for the red dash.
export function Val({ v }) {
  return v === NOT_AVAILABLE_TEXT ? <MissingDash /> : v;
}
